import { Injectable } from '@angular/core';
import { Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/observable/fromPromise';
import { DataService } from '../../core/data.service';

@Injectable()
export class OrderTemplateResolver implements Resolve<any> {

  constructor(private dataService: DataService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<any> {
    let tourTemplateId = +route.queryParamMap.get('tourtemplateid');
    let orderTemplateId = +route.queryParamMap.get('ordertemplateid');

    if (tourTemplateId && orderTemplateId) {
      return this.dataService.getOrderTemplate(orderTemplateId);
    }

    return Promise.resolve(null);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/resolvers/orderTemplate.resolver.ts